export enum IntroductionDetails {
  Introduction = 'Introduction',
  MusicalDimension = 'MusicalDimension',
  CulturalDimension = 'CulturalDimension',
  HistoricalDimension = 'HistoricalDimension',
  SignificantTerms = 'SignificantTerms',
}

export enum BaniSectionProps {
  OVERVIEW = 'Overview',
  COMMENTARY = 'Commentary',
  LITERAL_TRANSLATION = 'Literal Translation',
  POETIC_DIMENSION = 'Poetical Dimension',
  INTERPRETIVE = 'Interpretive Transcreation',
  CALLIGRAPHY = 'Calligraphy',
}

export const introductionDetailsLabels = {
  Introduction: 'Introduction',
  MusicalDimension: 'Musical Dimension',
  CulturalDimension: 'Cultural Dimension',
  HistoricalDimension: 'Historical Dimension',
  SignificantTerms: 'Significant Terms',
};

export const BaniListTypes = {
  FEATURED: 'Featured',
  UPCOMING: 'Upcoming',
};

export const SearchSortTypes = {
  ALPHABETIC: 'alphabetic',
  DATE: 'date',
};
